import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DriverVehiclePairModel } from '../../models/driver-vehicle-pair.model';

@Component({
  selector: 'driver-box',
  standalone: false,
  templateUrl: './driver-box.component.html',
  styleUrls: ['./driver-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverBoxComponent implements OnChanges {
  @Input() driver!: DriverVehiclePairModel;
  @Input() showCollapseButtons!: boolean;
  @Input() isRowExpanded!: boolean;

  @Output() expandRow = new EventEmitter<void>();
  @Output() collapseRow = new EventEmitter<void>();

  showAdditionalDriverInfo = false;
  clipboardCopyValue = '';
  showDebugInfo = false;

  toggleOnShowAdditionalDriverInfo(): void {
    this.showAdditionalDriverInfo = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['driver']) {
      this.clipboardCopyValue = `${this.driver.driverDisplayName || ''}`;
      this.clipboardCopyValue += `\n${this.driver.registrationNumber || ''}`;
      if (this.driver.trailerRegistrationNumber) {
        this.clipboardCopyValue += `/${this.driver.trailerRegistrationNumber}`;
      }
      this.clipboardCopyValue += `\n${this.driver.driver.PhoneNumber || ''}`;
      this.clipboardCopyValue += `\nBDO: ${this.driver.driver.BDO || ''}`;
    }
  }
}
